<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_content_area">
      <div class="title">詳細資料</div>
      <div class="sub_title"> {{ subtitle }} </div>
      <div class="white_block">
        <div class="table_holder">
          <table>
            <thead>
              <tr> <th>名稱</th> <th>填寫/查看</th> </tr>
            </thead>
            <tbody>
              <tr>
                <td>校外實習成績考評表</td>
                <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('intern-score-form')">填寫/查看</router-link> </td>
              </tr>
              <tr>
                <td>實習機構滿意度調查</td>
                <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('intern-satisfaction')">填寫/查看</router-link> </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import '~style/components/custom_table.scss'
export default {
  name: 'EnterprisesInternStudentDetailContent',
  components: {
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentInternStatusGetter',
      'currentInternRecordListGetter',
    ]),
    subtitle () {
      const curStudent = this.currentInternRecordListGetter.find(record => record.student_id == this.$route.params.sid);
      if(!curStudent) return "-";
      return [curStudent.department, curStudent.student_account, curStudent.student_name].join(' ');
    },
  },
  async created () {
    this.togglePageLoader(true);
    await this.getEnterpriseInternForm();
    if(this.currentInternStatusGetter == 'is_enabled') {
      await this.getInternRecordList({});
      this.togglePageLoader(false);
    }
    else {
      this.$router.push({ path: '/enterprises' });
    }
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/enterprises', [
      'getEnterpriseInternForm',
      'getInternRecordList',
    ]),
    detailPath(form_type) {
      return `/enterprises/intern/intern-record/${this.$route.params.year}/${this.$route.params.sid}/${form_type}`;
    },
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 29px;
  font-weight: bold;
  line-height: 42px;
  color: #000;
  margin-bottom: 36px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 23px;
    margin-bottom: 15px;
  }
}
.sub_title {
  font-size: 18px;
  line-height: 26px;
  color: #02A1E9;
  margin-bottom: 36px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 15px;
  }
}
</style>
